import { render } from "./CourseRegisteredCardSkeleton.vue?vue&type=template&id=5c6e5500"
import script from "./CourseRegisteredCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CourseRegisteredCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__